import { Routes } from '@angular/router';
import { EmployeeLoginComponent } from './components/employee-login/employee-login.component';
import { EmployeePreferencesComponent } from './components/employee-preferences/employee-preferences.component';
import { ManagerBuilderComponent } from './components/manager-builder/manager-builder.component';
import { UploadScheduleComponent } from './components/upload-schedule/upload-schedule.component';
import { PublicScheduleComponent } from './components/public-schedule/public-schedule.component';
import { RequestOffComponent } from './request-off/request-off.component';
import { authGuard } from './auth.guard';
import { managerGuard } from './manager.guard';
import { adminGuard } from './admin.guard';
import { loginGuard } from './login.guard';
import { ManageEmployeesPerOrgComponent } from './components/manage-employees-per-org/manage-employees-per-org.component';
import { AdminPanelComponent } from './components/admin-panel/admin-panel.component';
import { ShiftSwapRequestComponent } from './components/shift-swap-request/shift-swap-request.component';
import { DocumentationComponent } from './components/documentation/documentation.component';
import { TimesheetComponent } from './components/timesheet/timesheet.component';
import { timesheetGuard } from './timesheet.guard';
import { ManagerTimesheetsComponent } from './components/manager-timesheets/manager-timesheets.component';

export const routes: Routes = [
  { path: '', redirectTo: 'public-schedule', pathMatch: 'full' },

  // 🆕 Login page - only accessible when NOT logged in
  {
    path: 'login',
    component: EmployeeLoginComponent,
    canActivate: [loginGuard],
  },

  // Employee-Level Pages
  {
    path: 'public-schedule',
    component: PublicScheduleComponent,
    canActivate: [authGuard],
  },
  {
    path: 'requests',
    component: RequestOffComponent,
    canActivate: [authGuard],
  },
  {
    path: 'settings',
    component: EmployeePreferencesComponent,
    canActivate: [authGuard],
  },
  {
    path: 'shift-swap',
    component: ShiftSwapRequestComponent,
    canActivate: [authGuard],
  },
  {
    path: 'timesheet',
    component: TimesheetComponent,
    canActivate: [timesheetGuard],
  },
  {
    path: 'documentation',
    component: DocumentationComponent,
    canActivate: [authGuard],
  },

  // Manager/Store-Level Tools
  {
    path: 'manager/timesheets',
    component: ManagerTimesheetsComponent,
    canActivate: [managerGuard],
  },
  {
    path: 'manager',
    component: ManagerBuilderComponent,
    canActivate: [managerGuard],
  },
  {
    path: 'schedule',
    component: UploadScheduleComponent,
    canActivate: [managerGuard],
  },
  {
    path: 'manage-employees',
    component: ManageEmployeesPerOrgComponent,
    canActivate: [managerGuard],
  },
  // Admin-Level Pages
  { path: 'admin', component: AdminPanelComponent, canActivate: [adminGuard] },

  { path: '**', redirectTo: 'public-schedule' },
];
